import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import OpenSourceView from '@/views/OpenSourceView.vue'
import KotlinxView from '@/views/KotlinxView.vue'
import YSerialPortView from '@/views/YSerialPortView.vue'
import YutilsView from '@/views/YutilsView.vue'
import YuvcView from '@/views/YuvcView.vue'
import ResumeView from '@/views/ResumeView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView, meta: { title: '余静 · 开源作品与简历' } },
  { path: '/opensource', name: 'opensource', component: OpenSourceView, meta: { title: '开源项目 · 余静' } },
  { path: '/kotlinx', name: 'kotlinx', component: KotlinxView, meta: { title: 'kotlinx · Kotlin 扩展方法库' } },
  { path: '/yserialport', name: 'yserialport', component: YSerialPortView, meta: { title: 'YSerialPort · 安卓串口通信库' } },
  { path: '/yutils', name: 'yutils', component: YutilsView, meta: { title: 'yutils · Android 工具集合' } },
  { path: '/yuvc', name: 'yuvc', component: YuvcView, meta: { title: 'yuvc · USB UVC 摄像头方案' } },
  { path: '/resume', name: 'resume', component: ResumeView, meta: { title: '余静 · 个人简历' } }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0, behavior: 'smooth' }
  }
})

router.afterEach((to) => {
  if (to.meta?.title) document.title = to.meta.title
})

export default router
